export default __webpack_public_path__ + "static/media/2021ApplicationHyperComplex.78d321da.doc";